import type { TestRankingSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import { border } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

const TestRankingItemStyled = styled.div<{
  $styles: ElementStyleCss<TestRankingSchemaType>
  $isDragging: boolean
}>`
  display: flex;
  width: 100%;
  align-items: center;
  overflow: visible;

  padding: ${({ $styles }) => $styles.offset.padding};
  ${({ $styles }) => border($styles.border)}
  background-color: ${({ $styles }) => $styles?.item?.backgroundColor};
  box-shadow: ${({ $styles }) => $styles?.effects?.boxShadow};

  ${({ $isDragging, $styles }) =>
    $isDragging &&
    css`
      background-color: ${$styles.item_hover.backgroundColor};
    `}

  &:hover {
    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};
  }

  ${outline}
`

export default TestRankingItemStyled
